"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDatabaseTrashBlocked = isDatabaseTrashBlocked;
/**
 * A database the trash keeps out, in the editor and on the server alike: a
 * table the system protects (system-managed, schema-locked or owned by a
 * feature such as Mail, Planner, File Index or an app). Reads the props of a
 * database block, a discovery entry or the server's view of the host block.
 */
function isDatabaseTrashBlocked(props) {
    const { schemaLocked, systemManaged, managedBy } = props;
    return (schemaLocked === true ||
        systemManaged === true ||
        (typeof managedBy === 'string' && managedBy.length > 0));
}
